import { CacheHandler } from "reusable/utils/cache";

export const orgContextCache = {
   trial: new CacheHandler<boolean>({ key: 'org-context:trial', cacheLocation: 'localStorage' }),
   authOrgId: new CacheHandler<string>({ key: 'org-context:auth-org-id', cacheLocation: 'sessionStorage' })
}
